<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-text>
            <v-container>
              <v-row justify="center" class="black--text">
                <v-col cols="12" md="5">
                  <div>
                    <h2 class="text-md-h5">
                      Cek kode kelas
                    </h2>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="mb-3">
                    <p>
                      Mintalah kode kelas kepada pengajar, lalu masukkan kode di sini. Kode kelas yang terdiri dari 5-7 huruf atau angka, tanpa spasi atau simbol
                    </p>
                  </div>
                  <v-form
                    @submit.prevent="cekCode"
                    ref="formregjobseeker"
                    v-model="formadd.jobseeker"
                    lazy-validation>
                    <v-row justify="center" no-gutters>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <alertsp :alertdata="alertregjs"></alertsp>
                            <v-text-field
                              outlined
                              v-model="regjobseeker.classcode"
                              :rules="[rules.required]"
                              label="Kode kelas *"
                              name="classcode"
                              required>
                            </v-text-field>
                            <v-btn
                              large
                              block
                              :loading="loading.regjs"
                              :disabled="loading.regjs || !formadd.jobseeker"
                              :color="maincolor"
                              class="mr-4 white--text text-capitalize"
                              type="submit">
                              Cek Kode
                            </v-btn>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            Lihat kelas yang sudah ada punya?
                            <router-link :to="{ name: 'ListclassMhs' }">
                              Daftar kelas
                            </router-link>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                  <v-divider vertical></v-divider>
                </v-col>
                <v-col cols="12" md="6">
                  <div>
                    <h2 class="text-md-h5">
                      Hasil pengecekan
                    </h2>
                  </div>
                  <v-divider class="my-3"></v-divider>
                  <div class="mb-3" v-if="dclass.length <= 0">
                    <p class="red--text">
                      Hasil pengecekan kode kelas akan ditampilkan pada bagian ini!
                    </p>
                  </div>
                  <div class="mb-3" v-if="dclass.length > 0">
                    <v-row class="black--text">
                      <v-col cols="12" md="12">
                        <span class="text-subtitle-1">Program studi</span>
                        <h2 class="font-weight-bold">
                          {{ dclass[0].prodi_class }}
                        </h2>
                      </v-col>
                      <v-col cols="12" md="12">
                        <span class="text-subtitle-1">Semester</span>
                        <h2 class="font-weight-bold">
                          {{ dclass[0].semester_class }}
                        </h2>
                      </v-col>
                      <v-col cols="12" md="12">
                        <span class="text-subtitle-1">Mata kuliah</span>
                        <h2 class="font-weight-bold">
                          {{ dclass[0].matkul_class }}
                        </h2>
                      </v-col>
                      <v-col cols="12" md="12">
                        <span class="text-subtitle-1">Kelas</span>
                        <h2 class="font-weight-bold">
                          {{ dclass[0].mhs_class }}
                        </h2>
                      </v-col>
                      <v-col cols="12" md="12" v-if="listkelas.length > 0">
                        <p>Apakah anda yakin untuk bergabung dengan kelas berikut?</p>
                        <alertsp :alertdata="alertupdate"></alertsp>
                        <v-btn
                          class="white--text text-capitalize"
                          :color="maincolor"
                          @click="submitJoinclass"
                          :loading="loading.regcom"
                          :disabled="loading.regcom">
                          Gabung ke kelas
                        </v-btn>
                      </v-col>
                      <v-col cols="12" md="12" v-if="listkelas.length <= 0">
                        <div class="text-md-h6 red--text">Di SION Anda tidak terdaftar pada kelas ini!</div>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'JoinclassMhs',
  data: () => ({
    alertregjs: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      regjs: false,
      regcom: false,
      getdata: false,
    },
    publickey: '123',
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    baseurl: process.env.VUE_APP_BASEURL,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    regjobseeker: {
      classcode: '',
    },
    regcompany: {
      firstname: '',
      lastname: '',
      email: '',
      companyname: '',
      companyphone: '',
      password: '',
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      jobseeker: false,
      company: false,
      passwordjs: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
    dclass: [],
    tahunaktif: process.env.VUE_APP_TH,
    listkelas: [],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'userno',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getClassmhs() {
      this.listkelas = [];
      const datad = this.dclass[0];
      const strhex = this.tahunaktif +
        '' + this.userno +
        '' + this.hash;
      const hashactv = sha256(strhex);
      const senddata = {
        TahunAkademik: this.tahunaktif,
        KelasID: datad.s_kelas_id,
        NIM: this.userno,
        hashCode: hashactv.toUpperCase(),
      };
      // console.log(senddata);
      this.axios
        .post(
          this.apision + '/KelasPerkuliahaanMahasiswa',
          senddata,
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.listkelas = resdata.daftarKelas;
              // console.log(this.listkelas);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cekCode() {
      this.alertregjs.show = false;
      if (this.$refs.formregjobseeker.validate()) {
        if (this.tokenscr) {
          this.dclass = [];
          // console.log(this.regjobseeker);
          this.loading.regjs = true;
          this.axios
            .get(
              this.api + '/api/kelas/code/' + this.regjobseeker.classcode,
              {
                params: {},
                headers: {
                  Authorization: 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.dclass = resdata.data;
                  // console.log(this.dclass);
                  // get list class
                  this.getClassmhs();
                } else {
                  this.alertregjs.show = true;
                  this.alertregjs.type = 'error';
                  this.alertregjs.text = resdata.message;
                }
              } else {
                this.alertregjs.show = true;
                this.alertregjs.type = 'error';
                this.alertregjs.text = 'Internal services error!';
              }
              this.loading.regjs = false;
            })
            .catch((error) => {
              this.alertregjs.show = true;
              this.alertregjs.type = 'error';
              this.alertregjs.text = 'Internal services error!';
              this.loading.regjs = false;
            });
        } else {
          this.alertregjs.show = true;
          this.alertregjs.type = 'error';
          this.alertregjs.text = 'Invalid token!';
        }
      }
    },
    submitJoinclass() {
      this.alertupdate.show = false;
      if (this.tokenscr) {
        // console.log(this.regjobseeker);
        this.loading.regcom = true;
        this.axios
          .post(
            this.api + '/api/kelas/join',
            qs.stringify(
              {
                class: this.dclass[0].code_class,
                idclass: this.dclass[0].id_class,
                // s_krsd_id: '000205/KRS/PNB/022023-9',
                s_krsd_id: this.listkelas[0].krSd_ID,
              },
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.alertupdate.show = true;
                this.alertupdate.type = 'success';
                this.alertupdate.text = 'Selamat ada berhasil bergabung dengan kelas "' + this.dclass[0].matkul_class + '"';
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.regcom = false;
          })
          .catch((error) => {
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.regcom = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
